module.exports = __webpack_public_path__ + "static/media/BG_jeux_video.4f9ae842.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/BG_jeux_video.png
// module id = 240
// module chunks = 0